import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Images } from 'utils';
import { FooterCore } from '../../fragments';
import { ContactModal, SimpleModal } from 'components';

export const SimpleLanding = () => {
  const history = useHistory();
  const [openDel, setOpenDel] = useState(false);

  const handleOpenCloseDel = () => {
    setOpenDel(!openDel);
  };

  return (
    <>
      <div className="simple-landing-wrapper">
        <div className="landing-action-box">
          <img src={Images.logo} alt="logo" />
          <button onClick={() => history.push('/logIn')}>Sign In</button>
        </div>
        <FooterCore handleContact={handleOpenCloseDel} />
      </div>
      <SimpleModal
        handleOpenClose={handleOpenCloseDel}
        openDefault={openDel}
        content={<ContactModal text={''} handleClose={handleOpenCloseDel} />}
      />
    </>
  );
};